// const isDev=process.env.NODE_ENV === "development";
// export default class AppConfig {
//   static mingti_server= isDev ? "https://mt.51homemoney.com" : 'https://mt.51homemoney.com';//名帖服务//http://127.0.0.1:8181
//   static flow_server=isDev?'https://flow.gdzawy.com:9001' : 'https://flow.gdzawy.com:9001';//流程、人事服务
//   static erp_server=isDev?'https://api.oa.gdzawy.com:9001' : 'https://api.oa.gdzawy.com:9001';//流程、人事服务
//   static track_server=isDev?'https://log.gdzawy.com:9001' : 'https://log.gdzawy.com:9001';// 埋点服务
//   static ys_server=isDev?'https://budget.gdzawy.com:9001/' : 'https://budget.gdzawy.com:9001/';// 预算服务
//   static oss_server=isDev?'https://oss.gdzawy.com:9001' : 'https://oss.gdzawy.com:9001';// 对象存储服务
//   static log_server=isDev?'https://log.gdzawy.com:9001' : 'https://log.gdzawy.com:9001';// 日志服务
// }

const isDev=process.env.NODE_ENV === "development";
export default class AppConfig {
  static mingti_server= isDev ? window.Glob.mingti_server : window.Glob.mingti_server;//名帖服务//http://127.0.0.1:8181
  static flow_server=isDev? window.Glob.flow_server : window.Glob.flow_server;//流程、人事服务
  static erp_server=isDev? window.Glob.BuildErpApi : window.Glob.BuildErpApi;//流程、人事服务
  static track_server=isDev? window.Glob.track_server : window.Glob.track_server;// 埋点服务
  static ys_server=isDev? window.Glob.ys_server : window.Glob.ys_server;// 预算服务
  static oss_server=isDev? window.Glob.oss_server : window.Glob.oss_server;// 对象存储服务
  static log_server=isDev? window.Glob.track_server : window.Glob.track_server;// 日志服务
  static os_server=isDev? window.Glob.os_server : window.Glob.os_server;// 文件服务
}



// WEBPACK FOOTER //
// ./src/config/AppConfig.js